import { animated, useSpring, easings } from '@react-spring/web'

const animations = {
  fadeIn: {
    from: { opacity: 0 /*, transform: 'translate3d(0px,0px,0)'*/ },
    to: { opacity: 1 /*, transform: 'translate3d(0px,0px,0)' */ },
    //config: { tension: 500, friction: 50, clamp: true },
    config: { easing: easings.easeInExpo },
  },
}
export const useFadeIn = () => {
  const spring = useSpring(animations.fadeIn)
  return {
    animated,
    spring,
  }
}

export const useStaggerFadeIn = (index = 0) => {
  const spring = useSpring({
    from: { opacity: 0, transform: 'translate3d(0px,13px,0px)' },
    to: { opacity: 1, transform: 'translate3d(0px,0px,0px)' },

    config: { /*easing: easings.easeOutExpo,*/ friction: 24, tension: 240 },
    delay: 150 + index * 80,
  })
  return {
    animated,
    spring,
  }
}
